import { useMemo } from "react";
import { Media, AlertResponse, AreaHfb } from "../types/media";
import { removeAccents } from "../../../helpers/utils";
import { OngoingTaskLinksResponse } from "../types/taskLink";
import { FilterValue } from "@coworker/apprestructured/src/shared/filters/types/filter";
import { ArticleWithMediaCount } from "../types/article";
import { filterMediasByArticleHfb } from "../Helpers/hfbHelpers";
import { checkEdsFilter } from "../Helpers/filterHelpers";

export const useFilteredMediaCounts = (
  medias: (Media & AreaHfb)[],
  filterValues: FilterValue[],
  query: string,
  alerts?: AlertResponse[],
  tasks?: OngoingTaskLinksResponse,
  articlesFromHfb?: ArticleWithMediaCount[] | null
): Media[] => {
  return useMemo(() => {
    let filtered = [...medias];

    filterValues.forEach(({ filterId, value }) => {
      if (!value) return;

      switch (filterId) {
        case "status":
          filtered = filtered.filter((media) => media.active === value);
          break;
        case "area":
          filtered = filtered.filter((media) => media.areaHfb === value);
          break;
        case "articleHfb":
          filtered = filterMediasByArticleHfb(filtered, articlesFromHfb);
          break;
        case "sortBy":
          break;
        case "alerts":
          filtered = filtered.filter((media) => {
            const alert = alerts?.find(
              (a) => String(a.mediaId) === String(media.id)
            );
            const hasOngoingTask = tasks?.tasks?.some(
              (task) => String(task.media_id) === String(media.id)
            );

            if (value === "salesStop") return (alert?.salesStop ?? 0) > 0;
            if (value === "eds") {
              return checkEdsFilter(alert, filterValues, "eds");
            }
            if (value === "peds") {
              return checkEdsFilter(alert, filterValues, "peds");
            }
            if (value === "ongoingTasks") return hasOngoingTask;
            return false;
          });
          break;
        default:
          break;
      }
    });

    if (query) {
      const sanitizedQuery = removeAccents(
        query.toLowerCase().replace(/[.,]/g, "").trim()
      );

      filtered = filtered.filter((media) => {
        const sanitizedName = removeAccents(media.name?.toLowerCase() ?? "");
        const sanitizedMainProductName1 = removeAccents(
          media.mainProductName1?.toLowerCase() ?? ""
        );
        const sanitizedMainProductName2 = removeAccents(
          media.mainProductName2?.toLowerCase() ?? ""
        );

        return (
          sanitizedName.includes(sanitizedQuery) ||
          sanitizedMainProductName1.includes(sanitizedQuery) ||
          sanitizedMainProductName2.includes(sanitizedQuery)
        );
      });
    }

    return filtered;
  }, [medias, filterValues, query, alerts, tasks, articlesFromHfb]);
};
